import { useQuery } from '@tanstack/react-query';
import type { ApiError } from '@/shared/api/ApiError';
import type { AccessRole } from '../domain/entities/AccessRole';
import { getAccessRoleRepository } from '../infrastructure/repositories/container';
import { profileKeys } from './profileKeys';

export const useAccessRolesQuery = () =>
  useQuery<AccessRole[], ApiError>({
    queryKey: profileKeys.list(),
    queryFn: () => getAccessRoleRepository().listAll(),
    // CRITICAL: Execute queryFn even when offline — composite repo, Dexie fallback unreachable without this
    networkMode: 'always',
    staleTime: 5 * 60_000,
  });
